import React from 'react';
import Login from './LegacyViews/Login.jsx';
const Instructions = () => {
    return (
        <section className="services-area services-eight">

            <div className="container-doc">
                <div className="section-doc-left">
                    <div className="row">
                        <div className="col-12">
                            <div className="content">

                                <h1 className="fw-bold">Comment procéder à votre déclaration</h1>
                                <p>
                                    Vous devez nous envoyer vos documents fiscaux en PDF par courriel.
                                    (Vous pouvez établir un premier contact sur la section Contact du
                                    site.) </p>
                                <p>
                                    Veuillez noter que chaque déclaration d’impôts est traitée en
                                    fonction des divers documents que vous nous ferez parvenir.</p>

                                <p>
                                    Cette liste n'est pas exhaustive. Vous pouvez nous contacter au
                                    besoin pour toute autre question. Nous vous répondrons dans un
                                    délai de 24 heures.
                                </p>
                            </div>
                            <h6>Pour simplifier le rassemblement de tous vos feuillets,
                                déductions, dépenses et crédits d’impôt auxquels vous avez droit,
                                veuillez passer en revue les informations ci-dessous.</h6>
                        </div>
                    </div>
                </div>

                <div className="section-doc-right">

                    <div className="row">
                        <div className="col-12">
                            <div className="content">

                                <h1 className="fw-bold">Les 3 étapes</h1>
                                <p>
                                    1. Téléchargez et complétez le questionnaire d’informations
                                    personnelles. Celui-ci se trouve au bas de la section.
                                </p>
                                <p>
                                    2. Faites-nous parvenir vos documents PDF, incluant le formulaire
                                    des questions par courriel. Vous pouvez faire votre premier
                                    contact via notre site web.
                                </p>
                                <p>
                                    3. Un expert vous contactera pour assurer la prise en charge de
                                    votre dossier, payer les services, et signer les documents
                                    nécessaires. Nous prenons en charge la transmission électronique
                                    aux gouvernements provincial et fédéral. Vous recevrez par
                                    courriel une copie de votre déclaration complétée en format PDF.
                                </p>
                            </div>

                            <div>
                                <a
                                    href="/Downloads/Questionnaire de client pour la déclaration.docx"
                                    download>Questionnaire à télécharger</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>T4 et Relevé 1</h4>
                                <h6>Si vous avez occupé plus d’un emploi dans l’année en tant
                                    qu’employé salarié, vous devez ajouter tous vos T4 et Relevé
                                    1</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>T5 ou T3 </h4>
                                <h6>Si vous avez des revenus de placement, vous devez
                                    ajouter
                                    le sommaire des gains et pertes incluant vos T5 ou T3</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>Pension alimentaire </h4>
                                <h6>Si vous recevez une pension alimentaire imposable, indiquez le
                                    montant total reçu au cours de l’année</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>T4RIF </h4>
                                <h6>Si vous avez effectué des retraits de FERR</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>T4OAS et T4AP </h4>
                                <h6>Si vous retirez des rentes gouvernementales</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4> RC210 </h4>
                                <h6>Si vous avez reçu l'avance de l'allocation canadienne pour les
                                    travailleurs (ACT)</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>T4A </h4>
                                <h6>
                                    Si vous avez reçu une bourse pour vos études
                                    <hr />Si vous avez des revenus de travailleur autonome, ou
                                    travailleur à commission
                                    <hr />Si vous retirez des rentes privées
                                </h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>T5007 </h4>
                                <h6>Si vous avez eu un accident de travail
                                    <hr />Si vous recevez l’aide financière de dernier recours
                                </h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>T4RSP </h4>
                                <h6>Si vous avez effectué des retraits de REER pour la mise de fonds
                                    sur votre maison dans le cadre du RAP, veuillez joindre le
                                    feuillet T4RSP
                                    <hr />Si vous avez effectué des retraits de REER au courant de
                                    l’année
                                </h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>Relevé 5 </h4>
                                <h6>
                                    Si vous avez reçu des indemnités de la SAAQ pour un accident de la
                                    route
                                </h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h6>
                                    Si vous avez des revenus provenant de la location de vos
                                    immeubles, joignez votre rapport de revenus et dépenses locatives
                                </h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h6>Si vous êtes travailleur autonome, assurez-vous d’inclure un
                                    rapport de vos revenus et dépenses
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h3 className="custom-h3">Quels documents ajouter pour avoir droit à une déduction ou à un
                            crédit d’impôt ?</h3>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>REER</h4>
                                <h6>Vous devez joindre les reçus de cotisations à un REER dans
                                    l’année incluant les reçus de cotisations des 60 premiers jours de
                                    l’année suivante
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>Cotisations professionnelles ou syndicales </h4>
                                <h6> Vous devez joindre les reçus de cotisations à un ordre
                                    professionnel ou syndical
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>T2202 et Relevé 8</h4>
                                <h6> Étiez-vous un étudiant au niveau postsecondaire ou
                                    universitaire dans l’année ? Si oui, vous devez joindre les
                                    feuillets 2202 et le Relevé 8 fourni par votre établissement
                                    d’enseignement
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>Frais de garde pour enfants</h4>
                                <h6>Veuillez joindre les Relevés 24 ou tous les reçus contenant le
                                    nom, NAS et signature de la personne qui a fourni le service de
                                    garde
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>Activités physiques ou artistiques pour enfants</h4>
                                <h6>Si vous avez payé des activités physiques ou artistiques,
                                    veuillez joindre les reçus ( votre enfant doit avoir entre 5-16
                                    ans)
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>Dons de charité</h4>
                                <h6>Veuillez joindre tous les reçus si vous avez effectué des dons
                                    de charité à une institution reconnue par l’ARC
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>Intérêts payés sur un prêt étudiant</h4>
                                <h6>Si vous avez payé des intérêts sur un prêt étudiant, incluez le
                                    relevé fourni par votre institution financière indiquant le total
                                    payé dans l’année
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-content">
                                <h4>Frais médicaux </h4>
                                <h6>
                                    Si vous avez une assurance privée, vous devez demander à votre
                                    assureur le sommaire de toutes les dépenses médicales non
                                    remboursées par votre assurance
                                    <hr />Si vous n’avez pas d’assurance privée et que vous êtes assurés
                                    par la RAMQ, vous devez demander à votre pharmacien un rapport
                                    annuel pour fins d’impôts
                                    <hr />Ajoutez toute autre facture de frais ou services médicaux
                                    payés
                                    <hr />Nous examinerons chaque pièce jointe et déterminerons leur
                                    admissibilité
                                </h6>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default Instructions;

/* Add this CSS to your main stylesheet (e.g., App.css or Instructions.css)
.custom-h3 {
    color: hsla(208, 90%, 20%, 0.688);
    text-align: center;
}
*/